import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { domainActions } from '../../../store/domainStore';
import { REGISTRY, SEARCH_TYPE } from '../../../store/ceeSearchStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { Translate } from 'react-localize-redux';
import { withLocalize } from 'react-localize-redux';
import classnames from 'classnames'
import moment from 'moment';
import ResponsiveTable from '../../layoutItems/responsiveTable';

class ConfirmationComponent extends React.Component {
    radix10 = 10;

    constructor(props) {
        super(props);
        this.props.ensureDomainData('countries');
    }

    componentDidUpdate() {
        this.props.ensureDomainData('countries');
    }

    render() {
        return (
            <>
                {this.props.formData.birthId !== undefined && this.props.formData.birthId.replace('/', '').length !== 9 &&
                    parseInt(this.props.formData.birthId.replace('/', ''), this.radix10) % 11 !== 0 && <div className="notification is-danger">
                        <Translate id='Search.Common.PidDiv11Warning' />
                    </div>
                }
                {this.props.formData.notFound !== undefined && this.props.formData.notFound === true && <div className="notification is-danger">
                        <Translate id='Cee.Error.CompanyNotFound' />
                    </div>
                }
                {this.props.formData.isFop !== undefined && this.props.formData.isFop === true && <div className="notification is-danger">
                        <Translate id='Cee.Error.CompanyFOP' />
                    </div>
                }
                <span className="underlined-title-wrapper" style={{ marginBottom: "2em", marginTop: this.props.popup ? "0.5em" : "0" }}>
                    <h5 className="underlined-title" style={{ fontWeight: '600' }}>
                        {((requestType, registry) => {
                            switch (requestType) {
                                case SEARCH_TYPE.fo: {
                                    switch (registry) {
                                        case REGISTRY.cee:
                                        case REGISTRY.cre:
                                        case REGISTRY.rpve:
                                            return <Translate id='Search.Common.PersonEnquiry' />;
                                        case REGISTRY.aml:
                                            return <Translate id='Search.Common.PhysicalPerson' />;
                                        default:
                                            return '';
                                    }
                                }
                                case SEARCH_TYPE.fpo: return <Translate id='Search.Aml.ForeignCompany' />;
                                case SEARCH_TYPE.po: {
                                    switch (registry) {
                                        case REGISTRY.cee:
                                        case REGISTRY.cre:
                                        case REGISTRY.rpve:
                                            return <Translate id='Search.Common.CompanyEnquiry' />;
                                        case REGISTRY.aml:
                                            return <Translate id='Search.Aml.CzSkCompany' />;
                                        default:
                                            return '';
                                    }
                                }
                                case SEARCH_TYPE.trialFile: return <Translate id='Search.Common.TrialFileEnquiry' />;
                                case SEARCH_TYPE.bulk: return <Translate id='Search.Common.Bulk' />;
                                default: return '';
                            }
                        })(this.props.requestType, this.props.registry)
                        }
                    </h5>
                </span>
                <ResponsiveTable>
                    <table className="table table-report-section-2 table-cee-disclaimer w-100">
                        <tbody>
                            {this.props.formData.birthId !== undefined && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.Pid' />:
                                </td>
                                <td>
                                    {this.props.formData.birthId}
                                </td>
                            </tr>}
                            {this.props.formData.fullName !== undefined && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.FullName' />:
                                </td>
                                <td>
                                    {this.props.formData.fullName}
                                </td>
                            </tr>}
                            {(this.props.formData.firstName !== undefined || !isNullOrUndefined(this.props.formData.name)) && <tr className="colorize">
                                <td className="bold">
                                    <Translate id={
                                        (registry => {
                                            switch (registry) {
                                                case REGISTRY.aml: return 'Search.Aml.FirstName';
                                                default: return 'Search.Common.FirstName';
                                            }
                                        })(this.props.registry)} />:
                                </td>
                                <td>
                                    {this.props.formData.firstName || this.props.formData.name}
                                </td>
                            </tr>}
                            {this.props.formData.surname !== undefined && <tr className="colorize">
                                <td className="bold">
                                    <Translate id={
                                        (registry => {
                                            switch (registry) {
                                                case REGISTRY.aml: return 'Search.Aml.LastName';
                                                default: return 'Search.Common.Surname';
                                            }
                                        })(this.props.registry)
                                    } />:
                                </td>
                                <td>
                                    {this.props.formData.surname}
                                </td>
                            </tr>}
                            {this.props.formData.middleName !== undefined && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Aml.MiddleName' />:
                                </td>
                                <td>
                                    {this.props.formData.middleName}
                                </td>
                            </tr>}
                            {this.props.formData.birthDate !== undefined && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.BirthDate' />:
                                </td>
                                <td>
                                    {moment(this.props.formData.birthDate).format('L')}
                                </td>
                            </tr>}
                            {!isNullOrUndefined(this.props.formData.birthYear) && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.BirthYear' />:
                                </td>
                                <td>
                                    {this.props.formData.birthYear}
                                </td>
                            </tr>}
                            {this.props.formData.ico !== undefined  && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.CompanyId' />:
                                </td>
                                <td>
                                    {this.props.formData.ico}
                                </td>
                            </tr>}
                            {this.props.formData.address !== undefined && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.Address' />:
                                </td>
                                <td>
                                    {this.props.formData.address}
                                </td>
                            </tr>}
                            {this.props.formData.companyName !== undefined && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.CompanyName' />:
                                </td>
                                <td>
                                    {this.props.formData.companyName}
                                </td>
                            </tr>}
                            {this.props.formData.businessName !== undefined && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.BusinessName' />:
                                </td>
                                <td>
                                    {this.props.formData.businessName}
                                </td>
                            </tr>}
                            {this.props.formData.trialFileNumber !== undefined && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.TrialFileNumber' />:
                                </td>
                                <td>
                                    {this.props.formData.trialFileNumber}
                                </td>
                            </tr>}
                            {this.props.bulkFile !== undefined && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.FileName' />:
                                </td>
                                <td>
                                    {this.props.bulkFile.fileName}
                                </td>
                            </tr>}
                            {this.props.bulkCheck !== undefined && this.props.registry !== REGISTRY.aml && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.Bulk.Searches' />:
                                </td>
                                <td>
                                    {this.props.bulkCheck.numSearches}
                                </td>
                            </tr>}
                            {this.props.bulkCheck !== undefined && this.props.registry !== REGISTRY.aml && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.Bulk.Causes' />:
                                </td>
                                <td>
                                    {this.props.bulkCheck.numCauses}
                                </td>
                            </tr>}
                            {this.props.bulkCheck !== undefined && this.props.registry === REGISTRY.aml && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.Bulk.Persons' />:
                                </td>
                                <td>
                                    {this.props.bulkCheck.numSearches}
                                </td>
                            </tr>}
                            {this.props.bulkCheck !== undefined && this.props.registry === REGISTRY.aml && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.Bulk.Companies' />:
                                </td>
                                <td>
                                    {this.props.bulkCheck.numCauses}
                                </td>
                            </tr>}
                            {this.props.formData.city !== undefined && <tr className="colorize">
                                <td className="bold">
                                    <Translate id={
                                        (registry => {
                                            switch (registry) {
                                                case REGISTRY.aml: return 'Search.Common.City';
                                                default: return 'Search.Common.Municipality';
                                            }
                                        })(this.props.registry)
                                    } />:
                                </td>
                                <td>
                                    {this.props.formData.city}
                                </td>
                            </tr>}
                            {this.props.formData.gender !== undefined && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.Gender' />:
                                </td>
                                <td>
                                    {((gender, translate) => {
                                        switch (gender) {
                                            case 'M': return translate('Search.Common.Gender.Male');
                                            case 'F': return translate('Search.Common.Gender.Female');
                                            default: return '';
                                        }
                                    })(this.props.formData.gender, this.props.translate)}
                                </td>
                            </tr>}
                            {this.props.formData.country !== undefined && <tr className="colorize">
                                <td className="bold">
                                    <Translate id='Search.Common.Country' />:
                                </td>
                                <td>
                                    {this.props.countries.requestResult ?
                                        this.props.countries.requestResult.find(country => country.value === this.props.formData.country).label :
                                        this.props.formData.country}
                                </td>
                            </tr>}
                        </tbody>
                    </table>
                </ResponsiveTable>
                {this.props.includeMonetary !== undefined && this.props.includeMonetary === true && <ResponsiveTable>
                    <table className="table table-report-section-2 table-cee-disclaimer w-100">
                        <thead>
                            <tr>
                                <th colSpan="2">
                                    <Translate id='Search.Common.DownloadMonetaryObligationPart1' />
                                    &nbsp;
                                    <u>{this.props.maxCauses}</u>&nbsp;
                                    <Translate id='Search.Common.DownloadMonetaryObligationPart2' />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.monetaryData.maxTotalCauses !== undefined && (
                                <tr className="colorize">
                                    <td className="bold">
                                        <Translate id='Search.Common.TotalNumberOfCasesNotExceeding' />:
                                    </td>
                                    <td>
                                        {this.props.monetaryData.maxTotalCauses}
                                    </td>
                                </tr>
                            )}
                            {this.props.monetaryData.minCauseDate !== undefined && (
                                <tr className="colorize">
                                    <td className="bold">
                                        <Translate id='Search.Common.CaseNotOlderThan' />:
                                    </td>
                                    <td>
                                        {moment(this.props.monetaryData.minCauseDate).format('L')}
                                    </td>
                                </tr>
                            )}
                            {this.props.monetaryData.year !== undefined && (
                                <tr className="colorize">
                                    <td className="bold">
                                        <Translate id='Search.Common.CaseNotOlderThan' />:
                                    </td>
                                    <td>
                                        {this.props.monetaryData.year}
                                    </td>
                                </tr>
                            )}
                            {this.props.monetaryData.minCauseAmount !== undefined && (
                                <tr className="colorize">
                                    <td className="bold">
                                        <Translate id='Search.Cee.MinAmountOfMonetaryObligationPart1' />:
                                    </td>
                                    <td>
                                        {this.props.monetaryData.minCauseAmount}
                                        &nbsp;
                                        <Translate id='Search.Cee.MinAmountOfMonetaryObligationPart2' />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </ResponsiveTable>}
                <div className='has-text-centered' style={{ fontSize: ".875em", padding: "2em .3em .0em .3em" , display:  (isNullOrUndefined(this.props.formData.isFop) || this.props.formData.isFop === false) ? "block" : "none" }}>
                    <>
                        {(registry => {
                            switch (registry) {
                                case REGISTRY.cee: return (isNullOrUndefined(this.props.formData.isFop) || this.props.formData.isFop === false) ? <Translate id='Search.Common.ExecutionRegistryQuestion' options={{ renderInnerHtml: true }} data={{ country: 'CZ' }} /> :  null;
                                case REGISTRY.cre: return <Translate id='Search.Common.ExecutionRegistryQuestion' options={{ renderInnerHtml: true }} data={{ country: 'SK' }} />
                                case REGISTRY.rpve: return <Translate id='Search.Common.RpveQuestion' options={{ renderInnerHtml: true }}  />
                                case REGISTRY.aml: return <Translate id='Search.Aml.ConfirmationQuestion' />
                                default: return null;
                            }
                        })(this.props.registry)}
                        <br />
                        <br />
                        {(this.props.registry === REGISTRY.cee || this.props.registry === REGISTRY.cre || this.props.registry === REGISTRY.rpve) && (this.props.bulkCheck !== undefined && this.props.bulkCheck.isSuccess
                            ? <Translate id='Search.Common.CreditConsumptionInfoWithBulk' data={{
                                buttonLabel: this.props.translate('Common.Yes.Upper'),
                                account: this.props.bulkCheck.checkedPrice.AccountType,
                                amount: this.props.bulkCheck.checkedPrice.AmountFormatted,
                                disponible: this.props.bulkCheck.checkedPrice.DisponibleAmountFormatted
                            }} />
                            : this.props.includeMonetary === true
                                ? (isNullOrUndefined(this.props.formData.isFop) || this.props.formData.isFop === false) ? <Translate id='Search.Common.CreditConsumptionInfoWithMonetary' data={{
                                    buttonLabel: this.props.translate('Common.Yes.Upper'),
                                    account: this.props[this.props.registry + 'Check'].accountType,
                                    amount: this.props[this.props.registry + 'Check'].amountFormatted
                                }} /> : null
                                : ((isNullOrUndefined(this.props.formData.isFop) || this.props.formData.isFop === false)) ? <Translate id={'Search.Common.CreditConsumptionInfo' + (this.props.formData.amount === "1" ? "1" : "More")} data={{
                                    buttonLabel: this.props.translate('Common.Yes.Upper'),
                                    account: this.props[this.props.registry + 'Check'].accountType,
                                    amount: this.props[this.props.registry + 'Check'].amountFormatted
                                }} /> : null
                        )
                        }
                        {this.props.registry === REGISTRY.aml && (this.props.requestType === "bulk" && this.props.bulkCheck !== undefined && this.props.bulkCheck.isSuccess)
                            ? <Translate id='Search.Common.CreditConsumptionInfoWithBulk' data={{
                                buttonLabel: this.props.translate('Common.Yes.Upper'),
                                account: this.props.bulkCheck.checkedPrice.AccountType,
                                amount: this.props.bulkCheck.checkedPrice.Amount,
                                disponible: this.props.bulkCheck.checkedPrice.DisponibleAmount
                            }} />
                            : ((this.props.amlCheck !== undefined && this.props.amlCheck.isSuccess) && (
                                this.props.amlCheck.amount === 1.00
                                    ? <Translate id='Search.Aml.CreditConsumptionInfo1Unit'
                                        data={{ accountType: this.props.amlCheck.accountType, disponible: this.props.amlCheck.disponible }}
                                    />
                                    : <Translate id='Search.Aml.CreditConsumptionInfoMultipleUnits'
                                        data={{ accountType: isNullOrUndefined(this.props.amlCheck.accountType) ? "" : this.props.amlCheck.accountType, units: this.props.amlCheck.amount, disponible: this.props.amlCheck.disponible }}
                                    />
                            )
                            )
                        }
                        {(props => {
                            if (props.registry === REGISTRY.aml && props.amlCheck !== undefined && !!props.amlCheck.id) {
                                var type;
                                switch (props.requestType) {
                                    case SEARCH_TYPE.po:
                                        type = 'company';
                                        break;
                                    case SEARCH_TYPE.fo:
                                    case SEARCH_TYPE.fpo:
                                        type = 'person';
                                        break;
                                    default:
                                        return null;
                                }
                                return <React.Fragment>
                                    <br />
                                    <br />
                                    <span>
                                        <Translate id='Search.Aml.RequestAvailable'
                                            data={{ link: `/search/aml/results/${type}/${props.amlCheck.id}` }} options={{ renderInnerHtml: true }}
                                        />
                                    </span>
                                </React.Fragment>
                            } else return null;
                        })(this.props)}
                        <br />
                        <br />
                    </>
                </div>
                { (isNullOrUndefined(this.props.formData.isFop) || this.props.formData.isFop === false) &&
                <div className="modal-inner-buttons">
                    <button type='button' onClick={() => this.props.no()}
                        className={classnames('bb-button is-primary gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })}
                    >
                        <Translate id='Common.No.Upper' />
                    </button>
                    <button type='button' onClick={() => this.props.yes()}
                        className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                    >
                        <Translate id='Common.Yes.Upper' />
                    </button>
                </div>
                }
            </>
        )
    }
}

export default withLocalize(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch)
)(ConfirmationComponent));